import axios from "axios";

const apiKey = process.env.REACT_APP_API_BASE_URL;
const cdnBaseUrl = process.env.REACT_APP_CDN_URL;
const axiosInstance = axios.create({
 baseURL: `${apiKey}api/admin`,
});
const cdnInstance = axios.create({
  baseURL: `${cdnBaseUrl}api/`,
});
const getAccessToken = () => {
 return localStorage.getItem("token");
};


axiosInstance.interceptors.request.use(
 (config) => {
  const token = getAccessToken();
  if (token) {
   config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
 },
 (error) => {
  return Promise.reject(error);
 }
);
axiosInstance.interceptors.response.use(
 (response) => {
  return response;
 },
 (error) => {
  handleTokenErrors(error);
  return Promise.reject(error);
 }
);
export const handleTokenErrors = (error) => {
 if (error.response?.data?.message === "Unauthorized") {
  localStorage.removeItem("token");
  window.location.href = "/";
 }
};

export default axiosInstance;
export {cdnInstance }
